export default {
  ["agent_admin"]: `Halaman Agen`,
  ["edit_pwd"]: `Ubah Kata Sandi`,
  ["logout"]: `Keluar`,
  ["login"]: `Masuk`,
  ["register"]: `Daftar`,
  ["dashboard"]: `Dashboard`,
  ["registration"]: `Link pendaftaran`,
  ["incomes"]: `Komisi`,
  ["record"]: `Riwayat/catatan`,
  ["rules"]: `Aturan`,
  ["account"]: `Akun`,
  ["account_ph"]: `Masukkan akun yang benar`,
  ["password"]: `Kata sandi`,
  ["password_ph"]: `Masukkan kata sandi yang benar`,
  ["remember_account"]: `Ingat akun`,
  ["invite_ratio"]: `Undang pemain untuk mendapatkan`,
  ["invite_ratio_desc"]: `Laba/Rugi Bersih`,
  ["product_fee_ratio"]: `Biaya Produk`,
  ["product_fee_ratio_desc"]: `Laba/Rugi Bersih`,
  ["register_count"]: `Jumlah Pengguna Terdaftar`,
  ["login_count"]: `Jumlah Pengguna Login`,
  ["deposit_count"]: `Jumlah Pengguna Deposit`,
  ["first_deposit_count"]: `Jumlah Pengguna Deposit Pertama`,
  ["deposit_amount"]: `Jumlah Deposit`,
  ["withdraw_amount"]: `Jumlah Penarikan`,
  ["valid_bet_amount"]: `Jumlah Taruhan Sah`,
  ["win_amount"]: `Jumlah Kemenangan`,
  ["bonus_amount"]: `Bonus Promo`,
  ["profit_amount"]: `Total Laba/Rugi`,
  ["link_manage"]: `Pengelolaan Tautan/Link`,
  ["add_link"]: `Tambah Tautan/Link`,
  ["link_reached_limit"]: `Jumlah tautan telah mencapai batas maksimum`,
  ["copy_success"]: `Berhasil Disalin`,
  ["submit"]: `Kirim`,
  ["cancel"]: `Batal`,
  ["download"]: `Unduh`,
  ["sub_domain"]: `Subdomain`,
  ["sub_domain_ph"]: `Masukkan subdomain yang benar`,
  ["tag_name"]: `Nama Label`,
  ["tag_name_ph"]: `Masukkan nama label yang benar`,
  ["link_status_0"]: `Tanpa Status`,
  ["link_status_1"]: `Sedang dalam proses pengaturan`,
  ["link_status_2"]: `Sudah Aktif`,
  ["link_status_3"]: `Dapat Dicoba Ulang`,
  ["link_sttaus_4"]: `Tidak Tersedia`,
  ["month"]: `Bulan`,
  ["active_user_count"]: `Jumlah Pengguna Aktif`,
  ["product_fee_amount"]: `Biaya Produk`,
  ["dividend_ratio"]: `Persentase Biaya`,
  ["dividend_amount"]: `Komisi`,
  ["status"]: `Status`,
  ["dividend_bill_status_0"]: `Sedang Berjalan`,
  ["dividend_bill_status_4"]: `Menunggu Perhitungan`,
  ["dividend_bill_status_9"]: `Sudah Dibayar`,
  ["month_phase_1"]: `Periode Awal Bulan`,
  ["month_phase_2"]: `Periode Akhir Bulan`,
  ["click_here"]: `Klik di sini`,
  ["click_here_desc"]: `Hubungi admin akun Anda untuk melakukan penarikan USDT`,
  ["available_commission"]: `Komisi yang Bisa Didapat`,
  ["time"]: `Tanggal`,
  ["affiliate_program"]: `Program Afiliasi`,
  ["active_user_desc"]: `Penjelasan Pengguna Aktif`,
  ["payout_instructions"]: `Penjelasan Perhitungan`,
  ["payout_instructions_detail"]: `Setiap bulan, komisi dibayar 2 kali.</br>Periode 1: Tanggal 1–15, dibayar tanggal 20.</br>Periode 2: Tanggal 16–akhir bulan, dibayar tanggal 5 bulan berikutnya.`,
  ["rules_detail"]: `Hanya pemain yang mendaftar melalui tautan referensi agen yang berhak menerima komisi.</br>
Setiap agen wajib menanggung sebagian biaya operasional dan biaya promosi yang dihasilkan oleh anggotanya. Biaya tersebut akan dipotong dari periode keuntungan berikutnya.</br>
Hanya agen yang valid yang dapat menerima komisi (minimal 5 pengguna aktif dalam 2 minggu).</br>
Jika kerugian bulan sebelumnya berubah menjadi keuntungan, agen tidak akan menerima komisi, dan sisa kerugian akan dibawa ke bulan berikutnya.</br>
Setiap pengguna atau kelompok yang melakukan aktivitas kecurangan atau penyalahgunaan akan dibatalkan komisinya. Dalam kasus serius, akun terkait dapat dibekukan atau ditutup tanpa pemberitahuan, dan dana tidak akan dikembalikan. Pengguna tersebut juga akan dimasukkan ke dalam daftar hitam.</br>
Untuk mencegah penyalahgunaan dan pelanggaran kebijakan atau promosi, tim kontrol risiko akan melakukan pemeriksaan ketat terhadap setiap akun agen (termasuk nama, email, nomor telepon, dan lainnya). Jika ditemukan adanya penyalahgunaan atau kerja sama tidak wajar dengan agen lain, kami berhak membatalkan dan menyita saldo akun agen serta akun terkait tanpa pemberitahuan sebelumnya.</br>
Kami berhak menolak atau membekukan akun agen atau anggota kapan saja.`,
  ["get_withdraw"]: `Ambil Komisi`,
  ["commission_history"]: `Riwayat Komisi`,
  ["link_capacity"]: `Tersedia untuk membuat tautan`,
  ["language"]: `Bahasa`,
  ["old_password"]: `Kata Sandi Lama`,
  ["old_password_ph"]: `Masukkan kata sandi lama`,
  ["new_password"]: `Kata Sandi Baru`,
  ["new_password_ph"]: `Masukkan kata sandi baru`,
  ["confirm_password"]: `Konfirmasi Kata Sandi`,
  ["confirm_password_ph"]: `Silakan konfirmasi kata sandi`,
  ["confirm_password_not_same"]: `Konfirmasi kata sandi tidak sama`,
  ["operation_success"]: `Berhasil`,
  ["need_change_pwd_title"]: `Akun perlu mengubah kata sandi`,
  ["need_change_pwd_content"]: `Akun Anda perlu mengubah kata sandi untuk keamanan`,
  ["need_change_pwd_confirm"]: `Pergi Ubah`,
  ["err_5001"]: `Kesalahan sistem: gagal mengunci`,
  ["err_5002"]: `Kesalahan sistem: permintaan bertabrakan`,
  ["err_5003"]: `Data tidak valid`,
  ["err_6001"]: `Gagal masuk, akun diblokir`,
  ["err_6003"]: `Tidak bisa menambah tautan, sudah mencapai batas maksimum atau tautan sudah ada`,
  ["err_6004"]: `Terjadi konflik saat membuat tautan`,
  ["err_2003"]: `Kata sandi tidak valid`,
  ["err_2014"]: `Nama pengguna tidak valid`,
  ["date_picker_today"]: `Hari Ini`,
  ["date_picker_yesterday"]: `Hari sebelumnya`,
  ["date_picker_7_days"]: `7 Hari Terakhir`,
  ["date_picker_30_days"]: `30 Hari Terakhir`,
  ["date_picker_this_month"]: `Bulan Ini`,
  ["select_date_range"]: `Pilih Tanggal`,
  ["date_picker_ok"]: `OK`,
  ["start_date"]: `Tanggal Memulai`,
  ["end_date"]: `Tanggal Berakhir`,
  ["date_picker_year"]: `Tahun`,
  ["date_picker_month"]: `Bulan`,
  ["date_picker_day"]: `Hari`,
}